var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { display: "flex", "justify-content": "space-between" } },
    [
      _c("p", { staticClass: "results" }, [_vm._v(_vm._s(_vm.showMe))]),
      _vm._v(" "),
      _c("PaginationButtons", {
        attrs: {
          "current-page": _vm.pagination.currentPage,
          total: _vm.pagination.total,
          "per-page": _vm.pagination.perPage,
          "max-visible-buttons": 7,
          disabled: _vm.disabledPagination,
        },
        on: {
          change: function ($event) {
            return _vm.controlarCambioPagination($event)
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }